import cx from "classnames"
import type React from "react"

import type { CobaltButtonElement } from "../Buttons/Button"

type HelperPropsType = {
  children?: React.ReactNode
  className?: string
  title: string
  titleClassName?: string
  contentClassName?: string
  cta?: CobaltButtonElement
}

const Helper = ({
  className,
  titleClassName,
  contentClassName,
  title,
  children,
  cta,
}: HelperPropsType) => (
  <div className={cx("cobalt-helper", className)}>
    <strong className={cx("cobalt-helper__title", titleClassName)}>
      {title}
    </strong>
    <div className={cx("cobalt-helper__content", contentClassName)}>
      {children}
    </div>
    {cta}
  </div>
)

export default Helper
